/** Account.email の正規化（trim + 小文字化） */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase();
